import { Link, Text } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { MessageBanner } from '../MessageBanner'

type DuplicateBannerProps = {
  onPress: () => void
}

export const DuplicateBanner = (props: DuplicateBannerProps) => {
  const { t } = useTranslation()

  return (
    <MessageBanner variant="warning">
      {t('duplicate.banner.message')}&nbsp;
      <Text as="span" inherit weight="bold">
        <Link onClick={props.onPress}>{t('duplicate.banner.review')}</Link>
      </Text>
    </MessageBanner>
  )
}
